import React from 'react'

const StoreIcon = ({ width = '1em', height = '1em', fill = '#333', ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={width} height={height} {...props}>
    <path d='M15 18v-5.25h-2.25V18H15zm1.5 0H21V6H3v12h4.5v-6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v6zM9 18h2.25v-5.25H9V18zm.75-10.5h4.5a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zM3 4.5h18A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 18V6A1.5 1.5 0 0 1 3 4.5z' />
  </svg>
)

export default StoreIcon
